/* global Set */
/**
 * Investment-activity audience filters that accept several values: asset
 * class, instrument family, exact instrument, order direction and order type.
 *
 * They are sent as the list fields (`assetClassKeys`, `instrumentKeys`,
 * `instrumentIds`, `orderDirections`, `orderTypes`). A notification saved
 * before those existed holds the single field instead, so reading back takes
 * either.
 */

const asList = (...values) => [
  ...new Set(
    values
      .flat()
      .filter(value => value !== null && value !== undefined && value !== ''),
  ),
];

const listOrUndefined = (...values) => {
  const list = asList(...values);
  return list.length ? list : undefined;
};

/** Form field -> audience list field. */
const FIELDS = [
  ['audienceAssetClassKey', 'assetClassKeys', 'assetClassKey'],
  ['audienceInstrumentKey', 'instrumentKeys', 'instrumentKey'],
  ['audienceInstrumentId', 'instrumentIds', 'instrumentId'],
  ['orderDirection', 'orderDirections', 'orderDirection'],
  ['orderType', 'orderTypes', 'orderType'],
];

/** The audience list fields the admin set, ready for the payload. */
export const buildInvestmentListAudience = values => {
  const audience = {};
  FIELDS.forEach(([formField, listField]) => {
    const list = asList(values?.[formField]);
    if (list.length) audience[listField] = list;
  });
  return audience;
};

/** A saved notification's investment filters, back as form values. */
export const investmentAudienceToForm = audience => {
  const form = {};
  FIELDS.forEach(([formField, listField, singleField]) => {
    form[formField] = listOrUndefined(
      audience?.[listField] ?? [],
      audience?.[singleField],
    );
  });
  return form;
};
